<div class="--input-select-group" style="position: relative;" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <div class="--input-group d-flex justify-content-between align-items-center" [class.is-open]="isPanelOpen">
    <input autocomplete="off" type="text" [(ngModel)]="selectedItem" (ngModelChange)="onFilter($event)" (keydown)="onKeyDown($event)"
      (keyup)="!Readonly ? isPanelOpen = true : null" (click)="onPanelOpen()" [disabled]="Readonly" InputField
      (focus)="isFocused = true; !Readonly ? onPanelOpen() : null" (blur)="isFocused = false" />
    <label
      [ngClass]="{'disabled-label': Readonly && (isFocused || selectedItem.length > 0), 'disabled-color': Readonly && !selectedItem}"
      [class.floating]="isFocused || selectedItem.length > 0 || (IsChip && ChipsList.length > 0)">{{ inputLabel }} <span
        class="--text-red">{{ isRequired ?
        "*" : "" }}</span>
    </label>



    <!-- Downward arrow -->
    @if (isPanelOpen) {
    <span (click)="isPanelOpen = false; $event.stopPropagation()" class="cursor-pointer"
      [ngClass]="{'background-custom': Readonly}">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 30 25">
        <path d="m12 6.586-8.707 8.707 1.414 1.414L12 9.414l7.293 7.293 1.414-1.414L12 6.586z" />
      </svg>
    </span>
    }

    <!-- Upward arrow -->
    @if (!isPanelOpen) {
    @if (selectedItem.length > 0 && !Readonly && showClearButton) {
    <mat-icon class="--font-size-16 pe-1" (click)="onClear()" [ngClass]="{'disabled-color': Readonly}">close</mat-icon>
    }
    <span (click)="Readonly ? null : onPanelOpen()"
      [ngClass]="{'background-custom': Readonly, '--pointer-events-none': Readonly, 'cursor-pointer': !Readonly}">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="40" viewBox="0 0 30 25">
        <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z" />
      </svg>
    </span>
    }
  </div>
  <!-- Using CDK Overlay for the dropdown -->
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isPanelOpen"
    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPanelClass]="'input-select-dropdown-panel'"
    (backdropClick)="isPanelOpen = false; isFocused = false" [cdkConnectedOverlayWidth]="overlayWidth">

    <div class="dropdown overlay-dropdown">
      <div class="dropdown-content">
        <!-- Filter options in Multiple Select -->
        @if (IsChip) {
        <div class="dropdown-clear-icon ">
          <div class="d-flex align-items-center">
            <label class="d-flex align-items-center cursor-pointer">
              <input autocomplete="off" type="checkbox" [(ngModel)]="SelectAll" (change)="onSelectAll()"
                [disabled]="filteredList.length === 0" />
              <span class="--font-size-14 ms-1">Select All</span>
            </label>

            <label class="d-flex align-items-center cursor-pointer ms-3">
              <input autocomplete="off" type="checkbox" [(ngModel)]="SelectFiltered" (change)="onSelectFiltered()"
                [disabled]="filteredList.length === 0 || IsFiltered" />
              <span class="--font-size-14 ms-1">Filtered</span>
            </label>
          </div>
          <span class="filter-icon-wrapper" style="position: relative; display: inline-flex;">
            @if (ChipsList.length > 0) {
            <span class="chip-count-badge">{{ ChipsList.length }}</span>
            }
            @if (!IsFiltered) {
            <span matTooltip="Clear Filter" (click)="onClearFilter()" [class.disabled]="filteredList.length === 0">
              <!-- Clear filter icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 128 128">
                <g>
                  <path d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406
                        c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406
                        C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z
                        M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139
                        l-10.667,13.556c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171
                        c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623V57.896c1.651,1.9,3.548,3.582,5.642,4.996
                        v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758c-1.327,0.773-3.023,0.332-3.798-1.033
                        c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945
                        C1.355,0.258,2.056,0,2.756,0L2.756,0z
                        M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872
                        l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006
                        l-5.797-5.878l-5.807,5.889c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872
                        l5.83-5.913l-5.836-5.919c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006
                        l5.796,5.878L96.93,28.282z" />
                </g>
              </svg>
            </span>
            }
          </span>
        </div>
        }
        @for (item of filteredList; track $index) {
        <div class="dropdown-item d-flex justify-content-between align-items-center gap-2" #dropdownItem
          [class.highlighted]="highlightedIndex === $index" (click)="selectItem(item)">
          <div class="d-flex align-items-center">
            @if (IsChip) {
            <input autocomplete="off" type="checkbox" [checked]="item.IsChipSelected" (click)="selectItem(item); $event.stopPropagation()"
              class="me-2 flex-shrink-0" />
            }
            @if (item.dotColor) {
            <span class="flex-shrink-0 me-2" [style.backgroundColor]="item.dotColor" style="width: 12px; height: 12px; display: inline-block; border: 1px solid #9ca3af; border-radius: 2px;"></span>
            }
            <span style="line-height: 1.4; display: block; width: 100%;">{{ item.name }}</span>
          </div>
          @if (item.statusLabel) {
          <span class="{{item.statusClass}} flex-shrink-0">{{ item.statusLabel
            }}</span>
          }
        </div>
        }

        @if (filteredList.length === 0) {
        <div class="--font-size-14 --text-red d-flex justify-content-center align-items-center w-100 h-100 p-2">No
          Data
          Found</div>
        }
      </div>
    </div>
  </ng-template>

  <!-- Chips (inside the container) -->
  @if (ChipsList.length > 0) {
  <div class="chips-container">
    @for (item of ChipsList; track $index) {
    <div class="chip d-flex align-items-center justify-content-between">{{ item.name }} <mat-icon
        class="--font-size-14 ps-2" (click)="removeChip(item)">close</mat-icon></div>
    }
  </div>
  }
</div>
